import Header from "../header";
import {
  bannerimg,
  Icon01,
  Icon02,
  Icon03,
  Icon04,
  Join,
  PaypalIcon,
  CardIcon,
  LogoImage,
  Worst_school,
  Officers_images,
  Duragtion_image,
  Police_clock,
  DarkBlueImage,
  NotificationImage,
  BookImage,
  VectorImage,
  CheckImage,
  DifferenetImage1,
  DifferenetImage2,
  DifferenetImage3,
  CertificationIcon1,
  CertificationIcon2,
  CertificationIcon3,
  CertificationIcon4,
  ManagementImage,
  ShooterImage,
  PhoneImage,
  ArrowRight,
  IndividualTeacherImg,
  WhyNeedThisImg,
  logo,
} from "../imagepath";
import VideoCarousel from "../videoCarousel";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import BackgroundVideo from "../backgroundVideo";
import Course from "../course";
import TextTestimonial from "../textTestimonial";
// import Loginbg from "../../assets/img/banner.png";
// import BgBanner1 from "../../assets/img/bg-banner-01.png";
// import BgBanner2 from "../../assets/img/bg-banner-02.png";
// import Loginbg from "../../assets/img/banner.png";
// import UserLove from "../../assets/img/user-love.jpg";
import Footer from "../footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import styles from "./index.module.css";
import requests from "../../services/httpServices";


export const Home = () => {
  const mobileSidebar = useSelector((state) => state.sidebarSlice.expandMenu);
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [contactLoading, setContactLoading] = useState(false);
  const [contactSuccess, setContactSuccess] = useState("");
  const [contactError, setContactError] = useState("");
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    
    // Validate ReCAPTCHA
    if (!recaptchaValue) {
      setContactError("Please complete the reCAPTCHA verification.");
      return;
    }
    
    setContactLoading(true);
    setContactError("");
    setContactSuccess("");

    console.log("Submitting contact form");
    console.log("Form data:", contactForm);

    try {
      const result = await requests.post('/contact/submit', {
        name: contactForm.name,
        email: contactForm.email,
        message: contactForm.message
      });

      console.log("Success response:", result);
      setContactSuccess("Thank you! We will get back to you soon.");
      setContactForm({ name: "", email: "", message: "" });
      setRecaptchaValue(null); // Reset ReCAPTCHA
    } catch (error) {
      console.error("Network error:", error);
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to send message. Please try again.";
      setContactError(errorMessage);
    } finally {
      setContactLoading(false);
    }
  };
  // useEffect(() => {
  //   console.log(mobileSidebar,'gg');

  // }, [mobileSidebar]);

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <div
          className={`d-flex justify-content-center align-items-center ${styles.main_body}`}
        >
          <BackgroundVideo />
          <div
            className={`d-flex flex-row position-absolute align-items-center ${styles.displayBlock}`}
          >
            <img className={`${styles.logoImage}`} src={LogoImage} />
            <div className="d-flex flex-column">
              <p className={`${styles.topTitle}`}>AngelWatch</p>
              <p className={`${styles.bottomTitle}`}>
                The Only Emergency Training That Has Saved Lives
              </p>
            </div>
          </div>
        </div>

        <div className={`text-center ${styles.teachersSection}`}>
          <p className={`${styles.subTitle}`}>500K+ Users</p>
          <p className={`${styles.teacherSectionSubTitle}`}>
            TEACHERS / SCHOOLS / DAYCARES
          </p>
          <p className={`mx-auto ${styles.teacherSectionText}`}>
            AngelWatchedu.org is dedicated to providing educational resources
            and fostering a safe, supportive environment for students and
            learners.
          </p>
          <div className="my-5">
            <VideoCarousel />
          </div>
        </div>
        {/* <div className={`d-flex flex-row justify-content-center`}>
          <div className={`${styles.ratingSection}`}>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <p className={styles.numberText}>150+</p>
              <p className={styles.numberTitleText}>total courses</p>
            </div>
            <div className={`${styles.verticalLine}`}></div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <p className={styles.numberText}>250</p>
              <p className={styles.numberTitleText}>total instructor</p>
            </div>
            <div className={`${styles.verticalLine}`}></div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <p className={styles.numberText}>500K+</p>
              <p className={styles.numberTitleText}>total users</p>
            </div>
          </div>
        </div> */}
        <div className={`text-center ${styles.teachersSection}`}>
          <p className={`${styles.teacherSectionSubTitle}`}>
            WHAT TEACHERS || SCHOOLS || DAYCARES ARE{" "}
            <p className={`${styles.subTitle}`}>SAYING</p>
          </p>
          <div className="my-5">
            <TextTestimonial></TextTestimonial>
          </div>
        </div>

        <Course />

        <div className={`${styles.emergencymanagement} course`}>
          <p className={`${styles.certificationText} ${styles.emergency}`}>
            Free Emergency Management Packet (Included with Enrollment)
          </p>
          <div
            className={`d-flex flex-row mt-3 justify-content-center ${styles.certificationCircles}`}
          >
            <div className={styles.certificationCircleBlue}>
              <p className={styles.certificationCircleText}>
                State-Approved Standard Operating Procedures (SOPs)
              </p>
            </div>
            <div className={styles.certificationCircleRed}>
              <p className={styles.certificationCircleText}>
                Emergency Action Plan Templates for lockdowns, shelter-in-place,
                fires, and active threats
              </p>
            </div>
            <div className={styles.certificationCircleBlue}>
              <p className={styles.certificationCircleText}>
                Drill Scheduling & Compliance Logs to track emergency training
                requirements
              </p>
            </div>
            <div className={styles.certificationCircleRed}>
              <p className={styles.certificationCircleText}>
                Code Word Radio Communication Guide for discreet crisis response
              </p>
            </div>
            <div className={styles.certificationCircleBlue}>
              <p className={styles.certificationCircleText}>
                Threat Response Checklists for active shooters, intruders, and
                abductions
              </p>
            </div>
            <div className={styles.certificationCircleRed}>
              <p className={styles.certificationCircleText}>
                Crisis Communication Templates to notify parents and law
                enforcement
              </p>
            </div>
          </div>
        </div>

        <section className="bg-white d-flex flex-column align-items-center">
          <p className={`${styles.hardTruthTitle}`}>
            The Hard Truth: Law Enforcement Response is Too Late
          </p>
          <p className={`${styles.hardTruthSubTitle}`}>
            In an emergency, your staff are the first responders. The police
            will not arrive in time to stop the threat.
          </p>
          <div
            className={`d-flex flex-row justify-content-between ${styles.custom100Width} ${styles.displayBlock} ${styles.responseData}`}
          >
            <div className={`d-flex flex-row ${styles.hardTruthCard}`}>
              <div className="d-flex flex-column justify-content-between align-items-center">
                <img
                  className={styles.hardTruthCardImage1}
                  src={Police_clock}
                />
                <p className={styles.hardTruthCardText}>
                  Average police response time to an active shooter
                </p>
                <p></p>
              </div>
              <span className={styles.hardTruthCardSpan}>10-18 mins</span>
            </div>

            <div className={`d-flex flex-row ${styles.hardTruthCard}`}>
              <div className="d-flex flex-column justify-content-between align-items-center">
                <img
                  className={styles.hardTruthCardImage}
                  src={Duragtion_image}
                />
                <p className={styles.hardTruthCardText1}>
                  Average duration of a school shooting
                </p>
                <p></p>
              </div>
              <span className={styles.hardTruthCardSpan}>4-6 mins</span>
            </div>

            <div className={`d-flex flex-row ${styles.hardTruthCard}`}>
              <div className="d-flex flex-column justify-content-between align-items-center">
                <img
                  className={styles.hardTruthCardImage2}
                  src={Officers_images}
                />
                <p className={styles.hardTruthCardText2}>
                  Officers often take an additional
                </p>
                <p className={styles.hardTruthCardSubText}>
                  (3-5 minutes to assess before engaging)
                </p>
              </div>
              <span className={styles.hardTruthCardSpan}>3-5 mins</span>
            </div>

            <div className={`d-flex flex-row ${styles.hardTruthCard}`}>
              <div className="d-flex flex-column justify-content-between align-items-center">
                <img
                  className={styles.hardTruthCardImage3}
                  src={Worst_school}
                />
                <p className={styles.hardTruthCardText2}>
                  In some of the worst school shootings
                </p>
                <p className={styles.hardTruthCardSubText}>
                  (police waited outside while children and teachers were
                  killed)
                </p>
              </div>
              <span className={styles.hardTruthCardSpan}>waiting</span>
            </div>
          </div>

          <p className={styles.certificationText}></p>

          <div
            className={`d-flex flex-row align-items-center mt-5 pt-5 ${styles.displayBlock} ${styles.pricing__mobile}`}
          >
            <div className={styles.hardTruthMeaning}>
              <p className={styles.hardTruthMeaningText}>What This Means</p>
              <p className={styles.hardTruthMeaningSubText}>
                If your staff isn’t trained to react immediately, they are
                defenseless,
              </p>
              <p className={styles.hardTruthMeaningTitle}>
                AngelWatch is the only training program
              </p>
              <p className={styles.hardTruthMeaningSubText}>
                designed to ensure EVERY teacher, caregiver, and administrator
                has the skills to protect their students, themselves, and their
                colleagues—right from the first second of an attack.
              </p>
            </div>
            <section
          className={`d-flex flex-column align-items-center`}
        >
          <div
            className={`d-flex flex-row pt-5 mt-5 gap-5 justify-content-center ${styles.custom100Width} ${styles.displayBlock} ${styles.pricing__mobile}`}
          >
            <div className={styles.pricingCard}>
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Individual Teachers & Caregivers</span>
              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$900.00</p>
                <del className={styles.pricingOriginal}>Was $600</del>
                <p className={styles.pricingUnit}>/per year</p>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>
                  Annual Certification & Unlimited Training
                </p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Earn a recognized certification for every course</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Enhance your resume & career opportunities</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Train anytime, anywhere, as many times as needed</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Stay certified even if your school has not purchased
                      AngelWatch
                    </p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
            <div className={styles.pricingCard}>
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Schools & Daycares</span>
              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$9000.00</p>
                <del className={styles.pricingOriginal}>Was $6000</del>
                <p className={styles.pricingUnit}>/per year</p>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>
                  Unlimited Staff Training & Compliance Tracking
                </p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Train your entire staff for 12 months</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Includes state-approved SOPs and emergency management
                      system
                    </p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Covers new hires, recertifications, and ongoing updates at
                      no extra cost
                    </p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>The only training proven to save lives</p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
          </div>
        </section>
          </div>
        </section>

        <section
          className={`d-flex flex-column align-items-center ${styles.whatDifferent}`}
        >
          <div className={`d-flex flex-row justify-content-between`}>
            <div className={styles.whatDifferentLeft}>
              <img
                className={styles.whatDifferentSubImage}
                src={DifferenetImage1}
              />
              <img
                className={styles.whatDifferentSubImage}
                src={DifferenetImage2}
              />
              <img
                className={styles.whatDifferentSubImage}
                src={DifferenetImage3}
              />
            </div>
            <div className={styles.whatDifferentRight}>
              <p className={styles.whatDifferentRightTitle}>
                What Makes AngelWatch Different?
              </p>
              <p className={styles.whatDifferentRightSubTitle}>
                🚨 This isn’t a theory-based course. This is survival training.
              </p>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      We train for real emergencies
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      not just compliance.
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Our training is the ONLY program
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      that has saved lives in real situations.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Police training is built for officers
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      not for educators. AngelWatch teaches schools how to react
                      effectively under real conditions.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Interactive, real-time scenario training
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      ensures staff knows exactly what to do.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      We provide unlimited training access
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      because one session isn’t enough.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className={`d-flex flex-column align-items-center ${styles.certificationContent}`}
        >
          <p className={styles.certificationTitle}>
            What Schools & Daycares Receive with AngelWatch
          </p>
          <p className={styles.certificationText}>
            Certification for Each Emergency Protocol
          </p>
          <p className={styles.certificationSubText}>
            Certificates for every emergency course completed, ensuring
            compliance with state regulators. Display in your facility to
            reassure parents that your staff is fully trained and prepared.
          </p>

          <div
            className={`d-flex flex-row gap-5 py-2 align-items-center justify-content-center ${styles.gap3}`}
          >
            <img
              className={styles.certificationImage1}
              src={CertificationIcon1}
            />
            <img
              className={styles.certificationImage}
              src={CertificationIcon2}
            />
            <img
              className={styles.certificationImage}
              src={CertificationIcon3}
            />
            <img
              className={styles.certificationImage}
              src={CertificationIcon4}
            />
          </div>

          <div
            className={`d-flex flex-row gap-5 mt-5 pt-5 mb-5 ${styles.customWidth} ${styles.displayBlock}`}
          >
            <div
              className={`d-flex flex-row align-items-start gap-2 ${styles.certificationBottomCard}`}
            >
              <img className={styles.managementImg} src={ManagementImage} />
              <div className="d-flex flex-column gap-3">
                <p className={styles.managementCardTitle}>
                  Free Compliance Management System for Staff Training &
                  Tracking
                </p>
                <p className={styles.managementCardText}>
                  ✔ Securely stores and tracks staff emergency training records.
                  <br />✔ Provides proof of compliance for audits, inspections,
                  and licensing renewals. <br />✔ Eliminates paperwork—all
                  records stored digitally. <br />✔ Automatically logs each
                  teacher’s certification status so administrators can easily
                  verify training completion during inspections.
                </p>
              </div>
            </div>
            <div
              className={`d-flex flex-row align-items-start gap-2 ${styles.certificationBottomCard} `}
            >
              <img className={styles.managementImg} src={ShooterImage} />
              <div className="d-flex flex-column gap-3">
                <p className={styles.managementCardTitle}>
                  Advanced Active Shooter & Lockdown Training
                </p>
                <p className={styles.managementCardText}>
                  ✔ Interior & Exterior Threat Scenarios <br />✔ Egress
                  Evacuation & Shelter-in-Place Procedures <br />✔ Classroom
                  Child Accountability Under Crisis <br />✔ Coordinated Staff
                  Response Using Code Word Radio System <br />✔ Non-Lethal
                  Countermeasures to Prevent Harm
                </p>
              </div>
            </div>
          </div>

          <p className={`mt-5 ${styles.certificationTitle}`}>
            🔹 Your staff can take this training as many times as needed for 12
            months, ensuring they are always prepared for inspections and
            real-world emergencies.
          </p>
        </section>

        <section
          className={`d-flex flex-column justify-content-center align-items-center ${styles.TeachersSection} ${styles.displayBlock}`}
        >
          <div
            className={`d-flex flex-row ${styles.customWidth} ${styles.displayBlock}`}
          >
            <div className={styles.TeachersSectionLeft}>
              <p className={styles.TeachersSectionTitle}>
                AngelWatch for Individual Teachers & Caregivers
              </p>
              <p className={styles.TeachersSectionSubTitle}>
                Safety & Emergency Training for Educators—Be Prepared, Be
                Certified, Be Respected
              </p>
              <img
                className={styles.individualTeacherImg}
                src={IndividualTeacherImg}
              />
            </div>
            <div className={styles.teachersSectionRight}>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Meets Personal & State-Mandated Emergency Training
                  Requirements
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Gives Teachers an Extra Professional Credential for Their
                  Resume
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Prepares Educators for Real-World Emergencies in Any School or
                  Daycare
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Even if Your School or Daycare Hasn’t Purchased This
                  Certification—You Can
                </p>
              </div>
            </div>
          </div>

          <div
            className={`d-flex flex-column flex-md-row mt-5 pt-5 ${styles.customWidth}`}
          >
            <div className={styles.teachersSectionRight}>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  State laws require emergency preparedness training, but most
                  schools do not provide proper training.
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Emergency situations escalate quickly—this training teaches
                  how to react immediately and protect students.
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  AngelWatch certification provides proof of emergency training,
                  helping teachers stand out in job applications.
                </p>
              </div>
              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Train at your own pace—anytime, anywhere.
                  <br />
                  Rewatch training sessions as many times as needed.
                </p>
              </div>

              <div className={styles.teacherSectionCard}>
                <img src={CheckImage} />
                <p>
                  Includes all updates and new safety protocols throughout the
                  year.
                </p>
              </div>
            </div>
            <div className={styles.TeachersSectionLeft1}>
              <p className={styles.TeachersSectionTitle1}>
                Why Teachers & Caregivers Need This Training
              </p>
              <img className={styles.whyneedThisImg} src={WhyNeedThisImg} />
            </div>
          </div>
        </section>

        <section className="d-flex flex-column align-items-center">
          <p className={styles.TeachersSectionTitle1}>
            What Individual Teachers & Caregivers Receive
          </p>
          <div
            className={`d-flex flex-row gap-5 mt-5 pt-3 ${styles.customWidth} ${styles.displayBlock}`}
          >
            <div className={`${styles.IndividualCard} ${styles.custom90Width}`}>
              <div className="d-flex flex-row gap-4 align-items-start">
                <img src={CheckImage} className={styles.checkingList} />
                <p className={styles.IndividualCardTitle}>
                  Certification for Each Emergency Training Completed
                </p>
              </div>
              <p className={styles.IndividualCardText}>
                • Earn a recognized certificate for every emergency preparedness
                course. <br />• Boost your resume & job security with verified
                emergency training credentials. <br />• Proof of training can be
                submitted to your school, district, or daycare employer.
              </p>
            </div>
            <div className={`${styles.IndividualCard} ${styles.custom90Width}`}>
              <div className="d-flex flex-row gap-4 align-items-start">
                <img src={CheckImage} className={styles.checkingList} />
                <p className={styles.IndividualCardTitle}>
                  Advanced Active Shooter & Lockdown Training for Teachers
                  (Newly Expanded)
                </p>
              </div>
              <p className={styles.IndividualCardText1}>
                • How to Secure Your Classroom in an Active Threat <br />• How
                to Keep Students Calm & Accounted for in a Crisis <br />• What
                to Do If an Attacker Enters Your Classroom <br />• Evacuation
                Strategies for Teachers in an Active Shooter Event <br />• How
                to Use Code Word Communication to Get Help Fast
              </p>
            </div>
          </div>
        </section>

        <section className={`d-flex flex-column align-items-center`}>
          <p className={styles.youtube__text}>
            Train like lives depend on it—because they do
          </p>
          <div className={`position-relativ ${styles.youtube}`}>
            <iframe
              src="https://www.youtube.com/embed/SjENEj_DCXA"
              className={styles.youtube__video}
            ></iframe>
            <img
              src={require("../../assets/img/youtube__border.png")}
              className={styles.youtube__background}
            ></img>
          </div>
        </section>

        <section
          className={`d-flex flex-column align-items-center ${styles.pricingContent}`}
        >
          <p className={styles.pricingText}>$ Pricing</p>
          <div
            className={`d-flex flex-row pt-5 mt-5 gap-5 justify-content-center ${styles.custom100Width} ${styles.displayBlock} ${styles.pricing__mobile}`}
          >
            <div className={styles.pricingCard}>
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Individual Teachers & Caregivers</span>
              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$900.00</p>
                <del className={styles.pricingOriginal}>Was $600</del>
                <p className={styles.pricingUnit}>/per year</p>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>
                  Annual Certification & Unlimited Training
                </p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Earn a recognized certification for every course</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Enhance your resume & career opportunities</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Train anytime, anywhere, as many times as needed</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Stay certified even if your school has not purchased
                      AngelWatch
                    </p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
            <div className={styles.pricingCard}>
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Schools & Daycares</span>
              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$9000.00</p>
                <del className={styles.pricingOriginal}>Was $6000</del>
                <p className={styles.pricingUnit}>/per year</p>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>
                  Unlimited Staff Training & Compliance Tracking
                </p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Train your entire staff for 12 months</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Includes state-approved SOPs and emergency management
                      system
                    </p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Covers new hires, recertifications, and ongoing updates at
                      no extra cost
                    </p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>The only training proven to save lives</p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.contact__section}>
          <h1 className={styles.contact__heading}>Contact Us</h1>
          <div className={styles.contact}>
            <div>
              <h2 className={styles.contact__title}>
                For more information contact us
              </h2>

              <div>
                <img src={LogoImage} className={styles.contact__logoImg}></img>
              </div>
              <div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/email.png")}
                    className={styles.contact__img}
                  ></img>
                  <p className={styles.contact__item}>Edu@AngelWatch.org</p>
                </div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/call.png")}
                    className={styles.contact__img}
                  ></img>
                  <p className={styles.contact__item}>+1 800-381-6794</p>
                </div>
              </div>
            </div>
            <form onSubmit={handleContactSubmit} className={styles.contact__form}>
              <div>
                <p>Your name</p>
                <input
                  type="text"
                  className={styles.contact__input__info}
                  placeholder="John Smith"
                  value={contactForm.name}
                  onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                  required
                />
              </div>
              <div>
                <p>Your email</p>
                <input
                  type="email"
                  className={styles.contact__input__info}
                  placeholder="abc@gmail.com"
                  value={contactForm.email}
                  onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                  required
                />
              </div>
              <div className={styles.contact__message__form}>
                <p>Your message</p>
                <textarea
                  className={styles.contact__message__input}
                  value={contactForm.message}
                  onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                  required
                />
              </div>
              {contactSuccess && <p style={{ color: 'green', marginBottom: '10px' }}>{contactSuccess}</p>}
              {contactError && <p style={{ color: 'red', marginBottom: '10px' }}>{contactError}</p>}
              <button
                type="submit"
                style={{ marginBottom: "20px" }}
                disabled={contactLoading}
              >
                {contactLoading ? "Sending..." : "Send Message"}
              </button>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_SITE_KEY}
                className={`${styles.captcha}`}
                onChange={(value) => setRecaptchaValue(value)}
                onExpired={() => setRecaptchaValue(null)}
                onError={() => setRecaptchaValue(null)}
              />
            </form>
          </div>
        </section>

        {/* Master Skills */}
        {/* /Master Skills */}
        <section className="d-flex flex-column">
          <div className={styles.footerTop}>
            <div className={styles.footerSection}>
              <img className={styles.footerImage} src={logo} />
              <p className={styles.footerDes}>
                All of our techniques, trainings, equipment, software, hardware
                and instructions are considered classified material and owned by
                the AngelWatch Foundation. We do not share our information on
                how we teach. The reason, we keep the center, staff and children
                protected at all times. We never want anyone to try to figure
                out a way to bypass our trainings. We always improve, change and
                adapt to make sure that we have every base covered.
              </p>
            </div>

            <div className={styles.footerLoginSection}>
              <p className={styles.footerTitle}>School</p>
              <Link to="/login">
                <a className={styles.footerLink1}>Login</a>
              </Link>
              <Link to="/selectregister">
                <a className={styles.footerLink1}>Register</a>
              </Link>
            </div>

            <div className={styles.footerSection}>
              <p className={styles.footerTitle}>News Letter</p>
              <input
                className={styles.newsLetter}
                placeholder="Enter your email address"
                type="text"
              />
              <p className={styles.footerLink1}>
                3556 Beech Street, San Francisco, California, CA 94108
              </p>
              <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
              <p className={styles.footerLink1}>+1 800-381-6794</p>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomLeft}>
              <p className={styles.footerLink}>Term</p>
              <p className={styles.footerLink}>|</p>
              <p className={styles.footerLink}>Privacy</p>
            </div>
            <div className={styles.footerBottomRight}>
              <p className={styles.footerLink}>
                © 2025 AngelWatch LMS. All rights reserved.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
